import {AccordionItem, SectionTitle} from '@/components/molecules'
import {Accordion} from '@/components/molecules/Accordion'
import {PageContainer} from '@/components/organisms'
import InfoItem from '@/containers/OrderContainer/Common/InfoItem'
import {COLOR_CODE} from '@/utils/constants/colors'

const Section = ({id, title}) => {
  return <SectionTitle id={id} label={title} />
}

const PromotionAndReward = ({orderItemRewardData}) => (
  <>
    {/* Promotions Section */}
    <div className="order-overview">
      <div className="sc-border grid pl-4">
        <Section id="promotions" title="Promotions" />
      </div>
      <div className="grid grid-cols-3 gap-4 pb-6 pl-4">
        <InfoItem label="Promotional" value={orderItemRewardData?.promotional || '-'} />
        <InfoItem label="Promotion ID" value={orderItemRewardData?.promotionId || '-'} />
        <InfoItem label="Promotion Name" value={orderItemRewardData?.promotionName || '-'} />
      </div>
    </div>

    {/* Rewards Section */}
    <div className="order-overview">
      <div className="sc-border grid pl-4">
        <Section id="rewards" title="Rewards" />
      </div>
      <div className="grid grid-cols-3 gap-4 pb-6 pl-4">
        <InfoItem label="Reward Item ID" value={orderItemRewardData?.rewardItemId || '-'} />
        <InfoItem label="Total Points" value={orderItemRewardData?.totalPoints || '-'} />
        <InfoItem label="Type" value={orderItemRewardData?.type || '-'} />
        <InfoItem label="Reward Status" value={orderItemRewardData?.rewardStatus || '-'} />
        <InfoItem label="Expiration Date" value={orderItemRewardData?.expirationDate || '-'} />
        <InfoItem label="Reward Price" value={orderItemRewardData?.rewardPrice || '-'} />
        <InfoItem label="Route Type ID" value={orderItemRewardData?.routeTypeId || '-'} />
        <InfoItem label="Refunded" value={orderItemRewardData?.refunded || '-'} />
      </div>
    </div>
  </>
)
{
  /* Digital Product Section */
}
const DigitalProducts = ({orderItemRewardData}) => (
  <>
    <div className="order-overview">
      <div className="grid grid-cols-3 gap-4 pb-6 pl-4">
        <InfoItem label="Code" value={orderItemRewardData?.code || '-'} />
        <InfoItem label="Code Added" value={orderItemRewardData?.codeAdded || '-'} />
        <InfoItem label="Reference No" value={orderItemRewardData?.referenceNo || '-'} />
        <InfoItem label="URL" value={orderItemRewardData?.url || '-'} />
        <InfoItem label="ID" value={orderItemRewardData?.id || '-'} />
        <InfoItem label="Expired" value={orderItemRewardData?.expired || '-'} />
        <InfoItem label="Expiration Date" value={orderItemRewardData?.expirationDate || '-'} />
        <InfoItem label="Created" value={orderItemRewardData?.created || '-'} />
        <InfoItem label="Reward Order Number" value={orderItemRewardData?.rewardOrderNumber || '-'} />
        <InfoItem label="Sent to Source System" value={orderItemRewardData?.sentToSourceSystem || '-'} />
      </div>
    </div>
  </>
)

export const DigitalProductsAccordionContent = ({orderItemRewardData}) => {
  return (
    <AccordionItem
      label={<span style={{color: COLOR_CODE._FFFFFF, fontWeight: '700'}}>Digital Product</span>}
      isDark={true}
      content={<DigitalProducts orderItemRewardData={orderItemRewardData} />}
    />
  )
}

const OrderItemRewards = ({orderItemRewardData}) => {
  return (
    <>
      <PageContainer>
        <PromotionAndReward orderItemRewardData={orderItemRewardData} />
      </PageContainer>
      <div className="discountInfoAccordion mt-5">
        <Accordion
          isDark={true}
          content={<DigitalProductsAccordionContent orderItemRewardData={orderItemRewardData} />}
        />
      </div>
    </>
  )
}

export default OrderItemRewards
